import { render } from "./tabbar.vue?vue&type=template&id=52905bc8&scoped=true"
import script from "./tabbar.vue?vue&type=script&lang=js"
export * from "./tabbar.vue?vue&type=script&lang=js"

import "./tabbar.vue?vue&type=style&index=0&id=52905bc8&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52905bc8"]])

export default __exports__